import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TooltipOptionItem, TooltipOptionListItem } from '@luigiclaudio/ga-baseline-ui/tooltip';
import { useIntl } from 'react-intl';
import { useFormikContext } from 'formik';
import { ModalContext } from '@luigiclaudio/ga-baseline-ui/modal';
import ColorVariantActionsModal from '../ColorVariant/ColorVariantActionsModal';

const ColorTooltipOptionDetails = ({ colorValue, hideTooltip, modalProps }) => {
    const intl = useIntl();
    const { setFieldValue } = useFormikContext();
    const { showModal } = useContext(ModalContext);

    const colorValueCode = colorValue.slice(1);

    return (
        <TooltipOptionListItem>
            <TooltipOptionItem
                label={intl.formatMessage({
                    id: 'colorVariant.tooltip.option.viewDetails.label',
                })}
                icon="book-open"
                onClick={() => {
                    showModal(ColorVariantActionsModal, {
                        colorValue,
                        onClickSetMainColorCallback: () => setFieldValue('color', colorValueCode),
                        ...modalProps,
                    });
                    hideTooltip();
                }}
            />
        </TooltipOptionListItem>
    );
};

ColorTooltipOptionDetails.propTypes = {
    colorValue: PropTypes.string.isRequired,
    hideTooltip: PropTypes.func,
    modalProps: PropTypes.shape({
        showSetAsMain: PropTypes.bool,
        showAddRemoveFromLibrary: PropTypes.bool,
        showRemoveFromSelection: PropTypes.bool,
    }),
};

ColorTooltipOptionDetails.defaultProps = {
    hideTooltip: () => {},
    modalProps: undefined,
};

export default ColorTooltipOptionDetails;
